import Swal from 'sweetalert2';
import { get_token } from "@/router";
import { append_active_organization_id } from "@/utils/organization_profile";
import { buildJsonHeaders } from './create_form.utils';
import assignmentMethods from './create_form.assignment.methods';

export default {
    getToken() {
        return get_token();
    },
    show_toast(icon, title, text = '', timer = 3000) {
        Swal.fire({
            icon,
            title,
            text,
            position: 'bottom-end',
            showConfirmButton: false,
            timer,
            toast: true
        });
    },
    post_json(url, payload, { success, error, complete } = {}) {
        $.ajax({
            url,
            method: 'POST',
            headers: buildJsonHeaders(this.getToken()),
            data: JSON.stringify(payload),
            contentType: 'application/json',
            success,
            error,
            complete,
        });
    },
    post_json_request(url, payload) {
        return new Promise((resolve, reject) => {
            this.post_json(url, payload, {
                success: resolve,
                error: reject,
            });
        });
    },
    close_assign_modal() {
        $("#assignQuestionsModal").modal('hide');
    },
    reset_assignment_selections() {
        this.selected_profiles = [];
        this.selected_portals = [];
    },
    initialize_forms_table() {
        this.$nextTick(() => {
            if ($.fn.DataTable.isDataTable('.table')) {
                $('.table').DataTable().destroy();
            }

            $('.table').DataTable({
                paging: true,
                searching: true,
                ordering: true,
                info: true,
                lengthChange: true,
                pageLength: 10,
                language: {
                    paginate: {
                        previous: "Previous",
                        next: "Next"
                    },
                    info: "Showing _START_ to _END_ of _TOTAL_ entries",
                    infoEmpty: "No entries available"
                }
            });
        });
    },
    toggleSidebar() {
        this.$refs.sidebar.$el.classList.toggle("close");
    },
    toggle_selected_all_forms() {
        this.selected_forms = this.all_selected_forms ? this.forms.map((form) => form.id) : [];
    },
    show_create_form_loader() {
        Swal.fire({
            title: 'Submitting...',
            text: 'Please wait while we process your request.',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });
    },
    get_create_form_data() {
        const formData = new FormData();
        formData.append('form_name', this.form_name);
        formData.append('description', this.form_description);
        return formData;
    },
    handle_create_form_success(response) {
        if (response.status === "success") {
            Swal.fire({
                icon: "success",
                title: "Form created",
                showConfirmButton: false,
                timer: 1000,
                position: 'bottom-end',
                toast: true
            }).then(() => {
                this.forms.unshift(response.data);
                $('#create_form').modal('hide');
            });
        }
    },
    handle_create_form_error(response) {
        Swal.close();
        const response_data = response.responseJSON;
        if (response_data) {
            this.errors = response_data;
        }
    },
    createForm() {
        if (!this.validateForm()) {
            return;
        }

        this.show_create_form_loader();

        this.isSubmitting = true;

        $.ajax({
            type: 'POST',
            url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/create_form/`,
            data: this.get_create_form_data(),
            processData: false,
            contentType: false,
            headers: {
                'Authorization': `Token ${this.getToken()}`,
            },
            success: (response) => this.handle_create_form_success(response),
            error: (response) => this.handle_create_form_error(response),
            complete: () => {
                this.isSubmitting = false;
            },
        });
    },

    fetch_forms() {
        this.isLoading = true;
        this.token_exists = get_token();

        $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/filter_forms/`,
            method: "POST",
            headers: this.token_exists
                ? {
                    Authorization: `Token ${this.getToken()}`,
                    "Content-Type": "application/json",
                }
                : {},
            success: (response) => {
                this.forms = response.data.forms;
                this.initialize_forms_table();
            },
            complete: () => {
                this.isLoading = false;
            },
        });
    },

    validateForm() {
        this.errors = {};
        if (!this.form_name.trim()) {
            this.errors.form_name = 'Form name is required.';
        }
        return Object.keys(this.errors).length === 0;
    },

    getProfileTypes() {
        this.token_exists = get_token();
        $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/get_profile_types/`,
            method: "GET",
            headers: { Authorization: `Token ${this.getToken()}` },
            success: (response) => {
                this.profile_types = response.data;
            },
            error: () => {
                this.show_toast("error", "Failed to Load Profile Types", "An error occurred while fetching profile types. Please try again.");
            },
        });
    },

    resetForm() {
        this.form_name = '';
        this.form_description = '';
        this.errors = {};
    },

    assign_selected_form() {
        if (!this.selected_forms.length) {
            this.show_toast("error", "No Forms Selected", "Please select at least one form to assign.");
            return;
        }

        const payload = {
            form_ids: this.selected_forms,
            profile_tab_id: this.profile_tab_id || null,
        };

        this.post_json(
            `${process.env.VUE_APP_BACKEND_API_URL}/company_management/assign_profile_tab_form/`,
            payload,
            {
                success: (response) => {
                    if (response.status === "success") {
                        this.show_toast("success", "Forms Assigned", "Selected forms were successfully assigned.", 2000);
                    }
                    this.selected_forms = [];
                    this.all_selected_forms = false;
                },
                error: () => {
                    this.show_toast("error", "Assignment Failed", "An error occurred while assigning the forms.");
                }
            }
        );
    },

    delete_form(form_id) {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
            position: 'bottom-end',
            toast: true
        }).then((result) => {
            if (result.isConfirmed) {
                $.ajax({
                    type: 'DELETE',
                    url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/delete_form/`,
                    data: JSON.stringify({ form_id }),
                    contentType: 'application/json',
                    headers: {
                        'Authorization': `Token ${this.getToken()}`,
                    },
                    success: (response) => {
                        if (response.status === "success") {
                            this.show_toast('success', 'Deleted!', 'Your form has been deleted.');
                            this.forms = this.forms.filter((form) => form.id !== form_id);
                        }
                    },
                    error: () => {
                        this.show_toast("error", "Deletion Failed", "An error occurred while deleting the form. Please try again.");
                    }
                });
            }
        });
    },
    fetchPortals() {
        this.isLoading = true;
        $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_all_portals_api/`,
            method: 'POST',
            headers: buildJsonHeaders(this.getToken()),
            data: JSON.stringify(append_active_organization_id({})),
            success: (data) => {
                this.portals = data.portals.filter(
                    (portal) => portal.name?.toLowerCase() !== 'default portal'
                );
            },
            complete: () => {
                this.isLoading = false;
            }
        });
    },
    ...assignmentMethods,
};
